import styled from '@emotion/styled';

export const Container = styled.div`
    height:100%;
    width:100%;
    display:flex;
    align-items: center;
`; 

export const Badge = styled.div<{hideBadge?:boolean}>`
    width:100%;
    position: relative;
    padding:10% 0;
    display: flex;
    align-items: center;
    justify-content: center;

    svg{
        width:70%;
        z-index: 3;
        position: relative;
        position: absolute;
        left:50%;
        top:50%;
        transform: translate(-50%, -50%);

        path{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        rect{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        line{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        circle{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        polygon{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        ellipse{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        text{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
            font-size: auto;
        }
    }
`; 

export const BadgeBackground = styled.div<{colors?:any, earned?:boolean}>`
    position: absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%) rotate(45deg);
    z-index: 1;
    width:60%;
    aspect-ratio: 1/1;
    border-radius: 10px;
    border:8px solid ${props => props.colors?.border};
    background:${props => props.colors?.background};
`; 